import { render } from "./DongBoKetoanModal.vue?vue&type=template&id=7f51d096&scoped=true&ts=true"
import script from "./DongBoKetoanModal.vue?vue&type=script&lang=ts"
export * from "./DongBoKetoanModal.vue?vue&type=script&lang=ts"

import "./DongBoKetoanModal.vue?vue&type=style&index=0&id=7f51d096&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f51d096"]])

export default __exports__